import { z } from 'zod'

/**
 * Creates a schema that validates a non-empty array of elements matching the
 * given schema.
 *
 * Uses Zod v4's `z.tuple` with a rest element to express "at least one
 * element" — the canonical replacement for v3's `.array().nonempty()`.
 *
 * @example
 * ```ts
 * const schema = nonEmptyArraySchema(z.string())
 * // infers: [string, ...string[]]
 * ```
 */
export const nonEmptyArraySchema = <T extends z.ZodType>(schema: T) =>
  z.tuple([schema], schema)
